import React from "react";
import { BookOpen, Mic, Users } from "lucide-react";

// Custom 8-point Islamic star icon for Murabbi
const StarMurabbi = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <g stroke="#C9A961" strokeWidth="1.5" strokeLinejoin="round" fill="none">
      <path d="M32 6 L42 22 L58 32 L42 42 L32 58 L22 42 L6 32 L22 22 Z" />
      <path d="M32 14 L40 24 L50 32 L40 40 L32 50 L24 40 L14 32 L24 24 Z" />
    </g>
  </svg>
);

const PILLARS = [
  {
    icon: <BookOpen className="w-7 h-7 text-gold" strokeWidth={1.4} />,
    title: "EDUCATOR",
    body: "Developing minds through purposeful, values-driven education.",
  },
  {
    icon: <Mic className="w-7 h-7 text-gold" strokeWidth={1.4} />,
    title: "SPEAKER",
    body: "Inspiring audiences through faith, leadership, and meaningful conversations.",
  },
  {
    icon: <Users className="w-7 h-7 text-gold" strokeWidth={1.4} />,
    title: "MENTOR",
    body: "Guiding the next generation to become anchored, awakened, and advancing.",
  },
  {
    icon: <StarMurabbi className="w-7 h-7" />,
    title: "MURABBI",
    body: (
      <>
        Reviving the timeless role of the <span className="text-azure-soft">Murabbi</span> in our modern world.
      </>
    ),
  },
];

const PillarsStrip = () => {
  return (
    <section
      data-testid="pillars-strip"
      className="relative bg-ink-deep border-t border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-12 lg:py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
        {PILLARS.map((p, i) => (
          <div
            key={p.title}
            data-testid={`pillar-${p.title.toLowerCase()}`}
            className="flex gap-5"
          >
            <div className="shrink-0 mt-1">{p.icon}</div>
            <div>
              <div className="text-gold text-[12px] tracking-[0.32em] font-medium">
                {p.title}
              </div>
              <p className="text-white/65 text-sm leading-[1.75] mt-3 max-w-[230px]">
                {p.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PillarsStrip;
